import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setPagCount } from '../../actions/searchPagination';
import { getMaxCountLocal } from '../../helpers/pagination';

const ProductPagination = () => {
  const dispatch = useDispatch();
  const { pagCount, maxCount } = useSelector(state => state.pagCount);
  
  return (
    <div className='product-pagination pp-2'>
      <table className='product-pagination-tab'>
        <tbody>
          <tr>
            <td className='product-pag-td0'>
              <button onClick={() => {
                if(pagCount < 1 || pagCount === 1){
                  const newPagCount = 1;
                  dispatch(setPagCount(newPagCount));
                }else if(pagCount > 0){
                  const newPagCount = pagCount - 1;
                  dispatch(setPagCount(newPagCount));
                };
              }} className='product-button0'>Previous</button>
            </td>
            <td className='product-pag-td1'>
              <button onClick={() => {
                const getCountInStorage = getMaxCountLocal();
                const inputToInteger = Number(getCountInStorage);
                if(pagCount === inputToInteger){
                  const newPagCount = inputToInteger;
                  dispatch(setPagCount(newPagCount));
                }else if(pagCount < inputToInteger){
                  const newPagCount = pagCount + 1;
                  dispatch(setPagCount(newPagCount));
                };
              }} className='product-button1'>Next</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
};

export default ProductPagination;